import * as React from 'react';
import { GroupSettings } from './index';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from '../../reducers';
import { StudentData, emptyStudent } from '../../models/Student';
import * as GroupActions from '../../actions/group';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import * as Modal from 'react-modal';
import { Popup } from '../Common/popup';

export namespace StudentInfo{
	export interface Props extends RouteComponentProps<void> {
		student: StudentData;
		actions: Actions;
	}

	export interface State{
		modalOpen: boolean;
		firstname: string;
		lastname: string;
	}

	export interface Actions{
		updateStudent: (e: any)=>void;
		deleteStudent: (e: any)=>void;
		sendEmail: (e: any)=>void;
		createUsernames: (e: any)=>void;
		sendEmails: (e: any)=>void;
	}
}

export class StudentInfo extends React.Component<StudentInfo.Props, StudentInfo.State> {

	private username: HTMLInputElement;
	private email: HTMLInputElement;
	private student: StudentData;

	constructor(props: StudentInfo.Props){
		super(props);
		this.updateStudent = this.updateStudent.bind(this);
		this.deleteStudent = this.deleteStudent.bind(this);
		this.changeName = this.changeName.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);

		this.state = {
			modalOpen: false,
			lastname: this.props.student.lastname,
			firstname: this.props.student.firstname
		}
	}

	componentWillReceiveProps(nextProps: any){
		this.setState({
			firstname: nextProps.student.firstname,
			lastname: nextProps.student.lastname,
		});
	}

	changeName(values: any){
		this.setState({
			modalOpen: false
		});
		this.updateStudent(null, values.firstname, values.lastname);
	}

	updateStudent(e?: any, firstname?: string, lastname?: string){
		if(e)
			e.preventDefault();

		const studentData: StudentData = {
			group: this.props.student.group,
			_id: this.props.student._id,
			firstname: this.props.student.firstname,
			lastname: this.props.student.lastname,
			username: this.username.value,
			email: ''// this.email.value 
		};

		if(firstname)
			studentData.firstname = firstname;
		if(lastname)
			studentData.lastname = lastname;
		
		this.props.actions.updateStudent(studentData);
	}

	deleteStudent(e: any){
		e.preventDefault();
		this.props.actions.deleteStudent(this.props.student);
	}

	openModal(e: any){
		e.preventDefault();
		this.setState({modalOpen: true});
	}

	closeModal(e?: any){
		if(e)
			e.preventDefault();
		this.setState({modalOpen: false});
	}

	render(){
		let student = this.props.student;

		let popupelement = ( 
			<div>
				<h4>Anna oppilaan nimi</h4>
				<Popup.Form 
					inputs={[{name: 'firstname', type: 'text', placeholder: 'etunimi', value: this.state.firstname}, {name: 'lastname', type: 'text', placeholder: 'sukunimi', value: this.state.lastname}]} 
					buttons={[{text: 'TALLENNA OPPILAS', image: '/images/GreenPlusButton.png'}]} 
					accept={this.changeName} 
				/>
			</div>
		);

		return (
			<div>
				<p><b>Oppilaan tiedot</b></p>
				<div className="am_flexnoscroll am_innercontainer" key={student._id}> {/*key updates default values*/}
					<div className="margin10">
						<img src="/images/OnePerson.png" className="am_smallicon"></img>
						<h5 className="am_inline">{this.state.firstname} {this.state.lastname} </h5>
						<button onClick={this.openModal} className="btn am_darkblue-button am_smallbutton am_shadow">MUUTA NIMEÄ</button>
					</div>
					<div>
						<div className="col-12">
							<label className="col-3"><b>Tunnus: </b></label><input ref={(username)=>{this.username=username}} defaultValue={student.username} className="col-9"></input>
						</div>
						<div className="col-12">
							{/*<label className="col-3"><b>S-posti: </b></label><input ref={(email)=>{this.email=email}} defaultValue={student.email} className="col-9"></input>*/}
						</div>
						<div className="row mt-2">
							{/*<button className="btn am_blue-button am_smallbutton am_shadow mx-auto"><img src="/images/MailBlue.png" className="am_tinyicon"/>LÄHETÄ TUNNUS OPPILAAN SÄHKÖPOSTIIN</button>*/}
						</div>
						<div className="row mt-3 p-3">
							<div className="col-12 mb-2">
								<button onClick={this.updateStudent} className="btn am_green-button am_shadow col-12"><img src="/images/GreenConfirmButton.png" className="am_smallicon"/>TALLENNA MUUTOKSET</button>
							</div>
							<div className="col-12">
								<button onClick={this.deleteStudent} className="btn am_darkblue-button am_shadow col-12"><img src="/images/CrossButton.png" className="am_smallicon"/>POISTA OPPILAS</button>
							</div>
						</div>
					</div>
				</div>
				{/*<button className="btn am_orange-button am_shadow col-12 m-1 am_smalltext"><img src="/images/GreenConfirmButton.png" className="am_smallicon"/>LUO RYHMÄN KAIKILLE OPPILAILLE KERRALLA UUDET TUNNUKSET</button>
				<button className="btn am_blue-button am_shadow col-12 m-1 am_smalltext"><img src="/images/MailBlue.png" className="am_smallicon"/>LÄHETÄ KAIKILLE RYHMÄN OPPILAILLE TUNNUKSET SÄHKÖPOSTIIN</button>*/}
				<Modal isOpen={this.state.modalOpen} contentLabel="Minimal Modal Example" style={Popup.modalStyle}>
					<Popup.Element element={popupelement} closeModal={this.closeModal}/>
				</Modal>
			</div>	
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/GroupSettings/studentinfo.tsx